import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const bioMatrixScanVuex = createNamespacedHelpers("bioMatrixScan");
import cookie from "js-cookie";
export default {
  name: "popBioMatrixScanNext",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"]),
    ...bioMatrixScanVuex.mapState(['faceUidCountdown'])
  },
  data() {
    return {};
  },
  props: {},
  watch: {
    "$parent.popBioMatrixScanNextShow": {
      handler(newVal, oldVal) {
        if (!newVal && typeof oldVal !== 'undefined') {
          this.$parent.popBioMatrixScanNextShow = false;
          //cookie.set("advTip:"+this.userData.id+":"+this.setting.popadv.id,true, { expires: 1/this.setting.popadv.pop_times })
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    async onSubmit() {
      if (this.faceUidCountdown > 0) {
        return;
      }
      this.$parent.popBioMatrixScanNextShow = false;
    }
  }
};